import en from './en';
import es from './es';


const resources = { en, es };
export default resources;